import angular from 'angular';
import 'angular-bootstrap-colorpicker';
import { changePageTitle } from 'auth/actions/session.actions';
import TermsManagementComponent from './components/terms/terms-management-module';
import { CmsManageConfigurableLinkComponent } from './components/manage-configurable-link/manage-configurable-link-component';
import { CmsThemeComponent } from './components/theme/theme-component';

import ManageIconsModule from './components/manage-icons/manage-icons-module';
import BannersManagementModule from './components/banners/banners-management-module';
import GameImagesModule from './components/game-images/game-images-module';
import MediaTemplatesModule from './components/media-templates/media-templates-module';
import CmsPopupManagementModule from './components/login-popups/cms-popup-management-module';
import WidgetsManagementModule from './components/widgets/widgets-management-module';

export default angular
  .module('cms-management', [
    'colorpicker.module',
    TermsManagementComponent.name,
    ManageIconsModule.name,
    BannersManagementModule.name,
    GameImagesModule.name,
    MediaTemplatesModule.name,
    CmsPopupManagementModule.name,
    WidgetsManagementModule.name,
  ])
  .component('cmsManageConfigurableLink', new CmsManageConfigurableLinkComponent())
  .component('cmsTheme', new CmsThemeComponent())
  .config([
    '$stateProvider',
    function configure($stateProvider) {
      $stateProvider
        .state('cms-manageConfigurableLink', {
          parent: 'arw',
          url: '/cms-manage-configurable-link/',
          template: '<cms-manage-configurable-link></cms-manage-configurable-link>',
          redirectTo: 'permissions-denied',
          params: {
            pageTitle: [
              '$ngRedux',
              'gettextCatalog',
              ($ngRedux, gettextCatalog) => $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Manage Configurable Link'))),
            ],
          },
        })
        .state('cms-manageTheme', {
          parent: 'arw',
          url: '/cms-theme',
          template: '<cms-theme></cms-theme>',
          redirectTo: 'permissions-denied',
          params: {
            pageTitle: [
              '$ngRedux',
              'gettextCatalog',
              ($ngRedux, gettextCatalog) => $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Manage Website Color Palette'))),
            ],
          },
        });
    },
  ]);



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/cms-management-component.js